/**
 * GenerateResultView - Shows result after successful AI image generation.
 * Displays success message, image ID, and action buttons.
 */

import { Check, ExternalLink, RotateCcw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/v2/ui';

interface GenerateResultViewProps {
  imageId: string;
  productId: string;
  onConfirm: () => void;
  onReset: () => void;
}

export function GenerateResultView({
  imageId, productId, onConfirm, onReset,
}: GenerateResultViewProps) {
  const navigate = useNavigate();

  const handleStudioLink = () => {
    navigate(`/v2/tools/studio/single-shot?productId=${productId}&tab=product`);
  };

  return (
    <div className="flex flex-col items-center gap-4 py-6">
      <div className="flex items-center gap-2 text-emerald-600 dark:text-emerald-400">
        <Check className="h-5 w-5" />
        <span className="text-sm font-medium">Bild erfolgreich generiert</span>
      </div>

      <p className="text-xs text-neutral-500 dark:text-neutral-400 font-mono">
        ID: {imageId.slice(0, 8)}...
      </p>

      <div className="flex gap-2">
        <Button variant="primary" onClick={onConfirm}>
          <Check className="h-4 w-4 mr-1.5" />
          Als Referenz uebernehmen
        </Button>
        <Button variant="outline" onClick={onReset}>
          <RotateCcw className="h-4 w-4 mr-1.5" />
          Nochmal
        </Button>
      </div>

      <button
        type="button"
        onClick={handleStudioLink}
        className="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400"
      >
        <ExternalLink className="h-3 w-3" />
        Im Studio oeffnen
      </button>
    </div>
  );
}
